import { store } from "../../../../../../../stateManager";
import { pushFormActionStack, updateElement, updateElementOnUndoRedo } from "../../../../../../../stateManager/store/formCreation_v2/actions";
import { myRedoStack, myUndoStack } from "../../../stack/Stack";

type Props = {
  path: string;
  value: any;
  selectedElementId: string;
  oldValue: any;
  setOldValue(val: any): void;
}

export const onChange = (props: Props) => {
  const { dispatch } = store;
  const { path, value, selectedElementId, oldValue, setOldValue } = props;
  myUndoStack.push({
    id: selectedElementId,
    path,
    value: oldValue,
    label: "",
    properties: {},
    type: "",
    fields: []
  })
  myRedoStack.clear();
  dispatch(updateElement({
    id: selectedElementId,
    path,
    value
  }))
  dispatch(pushFormActionStack({
    undo: () => {
      const poppedElement = myUndoStack.pop();
      if (poppedElement) {
        myRedoStack.push({ ...poppedElement, value })
        dispatch(updateElementOnUndoRedo({
          id: poppedElement.id,
          path: poppedElement.path,
          value: poppedElement.value || "",
          increment: -1
        }))
      }
    },
    redo: () => {
      const poppedElement = myRedoStack.pop();
      if (poppedElement) {
        myUndoStack.push({ ...poppedElement, value: oldValue });
        dispatch(updateElementOnUndoRedo({
          id: poppedElement.id,
          path: poppedElement.path,
          value: poppedElement.value,
          increment: 1
        }))
      }
    }
  }))
  setOldValue(value);
}